"use client";

import HelpSellerPage from "@components/help/HelpSellerPage";

export default function Help() {
  return <HelpSellerPage />;
}
